export default "__VITE_ASSET__Bevs1nwt__"